module.exports = __webpack_public_path__ + "media/images/lb/869-f57a9ce1fc0e76a63d8995ffb05deee5.svg";